import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const usePaginatedDocuments = ({ 
  page, 
  rows = 10,
  patientId,
  patientName,
  documentType,
  status,
  sortBy = "created",
  sortDirection = "desc",
  mydocs
}) => {

  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["documentsList", tenantVal, page, rows, patientId, patientName, documentType, status, sortBy, sortDirection, mydocs],
    queryFn: async () => {
      const axiosInstance = await createAxiosInstance();

      const params = new URLSearchParams({
        page: page.toString(),
        rows: rows.toString(),
        sortBy,
        sortDirection
      });

      if (patientId) params.append("patientId", patientId);
      if (patientName && patientName.trim()) params.append("patientName", patientName.trim());
      if (documentType && documentType.trim()) params.append("documentType", documentType.trim());
      if (status) {
        const statusVal = Array.isArray(status) ? status.filter(Boolean).join(",") : status;
        if (statusVal && String(statusVal).trim()) params.append("status", String(statusVal).trim());
      }
      if (mydocs) params.append("mydocs", "true");

      const response = await axiosInstance.get(
        `${tenantVal}/document/page?${params.toString()}`
      );
      return response.data;
    },
    enabled: !!tenantVal,
    staleTime: 1000 * 60 * 5,
    meta: { errorMessage: "Error fetching documents" },
  });
};